<template>
  <div>
    <highcharts :id="id" class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
import highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'

exportingInit(highcharts)

var idx = 0

export default {
  props: {
    QuestM: {
      type: Object,
      default: () => {},
    },
    QuestD: {
      type: Array,
      default: () => {},
    },
  },
  created() {
    this.init()
  },
  data() {
    idx++
    return {
      id: 'ChartBellCurve' + String(idx),
      chartOptions: {
        chart: {
          type: 'column',
        },
        //

        title: {
          text: this.QuestM.cnName,
        },

        xAxis: [
          {
            title: {
              text: '數值',
            },
            alignTicks: false,
          },
          {
            title: {
              text: '',
            },
            alignTicks: false,
            opposite: true,
            visible: false,
          },
        ],

        yAxis: [
          {
            title: { text: '人數' },
          },
          {
            title: { text: 'Bell curve' },
            visible: false,
          },
        ],

        series: [
          {
            name: 'Bell curve',
            type: 'bellcurve',
            xAxis: 1,
            yAxis: 1,
            baseSeries: 1,
            zIndex: -1,
          },
          {
            name: 'Data',
            type: 'scatter',
            data: [],
            accessibility: {
              exposeAsGroupOnly: true,
            },
            marker: {
              radius: 1.5,
            },
          },
        ],

        //
      },
    }
  },
  mounted() {  
    var obj = {
      'id': this.id,
      'option': this.chartOptions
    }

    this.$store.state.charts.push(obj);

    // var chart = Highcharts.chart(this.id, this.chartOptions)
    // this.$store.state.charts.push(chart)

    },
  methods: {   
  
    init() {
      let tmpName = ''

      //this.chartOptions.series[0].name = '人數'
      for (let i = 0; i < this.QuestD.length; i++) {
        if (this.QuestD[i].enName == this.QuestM.enName) {
          if (this.QuestD[i].enName != tmpName) {
            tmpName = this.QuestD[i].enName
            window.console.log(this.QuestD[i].miniNum)
            window.console.log(this.QuestD[i].maxiNum)
            let nm = this.QuestD[i].miniNum
            let sl = this.QuestD[i].maxiNum
            window.console.log((parseInt(sl) + 1))
            for (let i = parseInt(nm); i < (parseInt(sl) + 2); i++) {
              this.chartOptions.series[1].data.push(null)
            }            
          }

          for (let j = 0; j < this.QuestD[i].sum; j++) {
            if(this.chartOptions.series[1].data[parseInt(this.QuestD[i].options)] === null){
              this.chartOptions.series[1].data[parseInt(this.QuestD[i].options)] = 0
            }
            this.chartOptions.series[1].data[parseInt(this.QuestD[i].options)]++
            //this.chartOptions.series[1].data.push(parseInt(this.QuestD[i].options))
            //window.console.log("ans:" + this.QuestD[i].options)
          }
        }
      }
      window.console.log(this.chartOptions.series[1].data)
    },
  },
}
</script>
